<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-sm-12 m-0 p-0">
                <form class="" @submit.prevent="submit">
                    <div class="col-lg-10 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3">
                        <!-- title -->
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.title }}<span class="required-star"></span>
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="150"
                                    v-model="fields.title"
                                />
                                <small class="form-text text-muted">
                                    {{ trans.title_150_characters }}
                                </small>
                                <span class="text-danger" v-if="errors && errors.title">{{
                                    errors.title[0]
                                }}</span>
                            </div>
                        </div>
                        <!-- sub title -->
                        <div class="form-group row" v-if="isShowField('sub_title')">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.sub_title }}
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="100"
                                    v-model="fields.sub_title"
                                />
                                <small class="form-text text-muted">
                                    {{ trans.help_text.sub_title }}
                                </small>
                                <span class="text-danger" v-if="errors && errors.sub_title">{{
                                    errors.sub_title[0]
                                }}</span>
                            </div>
                        </div>
                        <!-- tag -->
                        <div class="form-group row" v-if="isShowField('tags')">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.tag }}
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control"
                                    :class="'selectize-' + locale"
                                    name="tags"
                                    v-model="tags"
                                />
                                <small class="form-text text-muted mt-0">
                                    {{ trans.help_text.tag }}
                                </small>
                                <span class="text-danger" v-if="errors && errors.tags">{{
                                    errors.tags[0]
                                }}</span>
                            </div>
                        </div>
                        <!-- description -->
                        <div class="form-group row" v-if="isShowField('description')">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.description }}
                            </label>
                            <div class="col-sm-9">
                                <textarea
                                    class="form-control"
                                    v-model="fields.description"
                                    rows="10"
                                ></textarea>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.description }}
                                </small>
                                <span class="text-danger" v-if="errors && errors.description">{{
                                    errors.description[0]
                                }}</span>
                            </div>
                        </div>
                        <!-- custom fields -->
                        <hr />
                        <div class="form-group row" v-if="isShowField('custom_fields')">
                            <div class="col-sm-12">
                                <h5 class="">
                                    {{ trans.custom }}
                                </h5>
                            </div>
                        </div>
                        <div
                            class="form-group row"
                            v-for="(customField, index) in fields.custom_fields"
                            :key="index"
                        >
                            <div class="col-sm-3">
                                <label v-if="isFixedTitle(fields.custom_fields[index].title)">
                                    {{ getTitleCustomField(fields.custom_fields[index].title) }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="64"
                                    v-model="fields.custom_fields[index].title"
                                    v-else
                                />
                                <p
                                    class="text-danger"
                                    v-if="getFirstError('custom.' + index + '.title')"
                                >
                                    {{ getFirstError('custom.' + index + '.title') }}
                                </p>
                            </div>
                            <div class="col-sm-7">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="fields.custom_fields[index].text"
                                    v-if="
                                        fields.custom_fields[index].title ==
                                            trans.custom_fields.phone_number ||
                                        fields.custom_fields[index].title == trans.custom_fields.url
                                    "
                                />
                                <textarea
                                    rows="10"
                                    v-model="fields.custom_fields[index].text"
                                    class="form-control"
                                    v-else
                                ></textarea>
                                <p
                                    class="text-danger"
                                    v-if="getFirstError('custom.' + index + '.text')"
                                >
                                    {{ getFirstError('custom.' + index + '.text') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="col-lg-10 col-sm-12 mb-5 mt-4 clearfix">
                    <button
                        class="btn btn-primary w-25 center float-right submit-btn"
                        :disabled="isDisabled"
                    >
                        {{ trans.btn.update }}
                    <div v-if="isDisabled" class="spinner-border spinner-border-sm text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        formAction: {
            type: String,
            required: true
        },
        locationData: {
            type: Object,
            required: true
        },
        locationTranslations: {
            type: Object,
            default: function () {
                return null;
            }
        },
        trans: {
            type: Object,
            required: true
        },
        locale: {
            type: String,
            required: true
        }
    },
    computed: {
        fixedTitles() {
            return Object.values(this.trans.custom_fields);
        }
    },
    data() {
        return {
            fields: {
                title: !this.locationTranslations
                    ? this.locationData.title
                    : this.locationTranslations.title,
                sub_title: !this.locationTranslations
                    ? this.locationData.sub_title
                    : this.locationTranslations.sub_title,
                description: !this.locationTranslations
                    ? this.locationData.description
                    : this.locationTranslations.description,
                custom_fields: !this.locationTranslations || this.locationTranslations.custom_fields.length == 0
                    ? this.locationData.custom_fields
                    : this.locationTranslations.custom_fields
            },
            tags: !this.locationTranslations
                ? this.locationData.tags
                : this.locationTranslations.tags,
            errors: {},
            isDisabled: false
        };
    },
    methods: {
        getFirstError(field) {
            if (this.errors.length == 0) {
                return;
            }
            for (const key in this.errors) {
                if (key == field) {
                    return this.errors[key][0];
                }
            }
            return;
        },
        isFixedTitle(title) {
            const { custom_fields, custom_fields_fixed } = this.trans;
            return Object.values(custom_fields).includes(title) || Object.values(custom_fields_fixed).includes(title);
        },
        getTitleCustomField(title) {
            const { custom_fields, custom_fields_fixed } = this.trans;
            let index = Object.values(custom_fields).indexOf(title);
            let indexFixed = Object.values(custom_fields_fixed).indexOf(title);
            return custom_fields[Object.keys(custom_fields)[index]] || custom_fields[Object.keys(custom_fields_fixed)[indexFixed]];
        },
        submit() {
            this.isDisabled = this.$parent.$refs['locationForm'].isDisabled;
            if (!this.isDisabled) {
                return;
            }
            var self = this;
            this.fields.locale = this.locale;
            this.fields.tags = this.tags;
            axios({
                method: 'PUT',
                url: this.formAction,
                data: this.fields
            })
                .then((response) => {})
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                });
        },
        bindingSelectizeFields() {
            var self = this;
            $('.selectize-' + this.locale).selectize({
                plugins: ['remove_button'],
                delimiter: ',',
                persist: false,
                create: function (input) {
                    return {
                        value: input,
                        text: input
                    };
                },
                onChange: function (value) {
                    const field = this.$input['0'].name;
                    self[field] = value;
                }
            });
        },
        isShowField(field) {
            if (!this.locationTranslations) {
                return !!this.locationData[field];
            }

            return !!this.locationData[field] || !!this.locationTranslations[field];
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                    });
                }
            }
        },
    },
    mounted() {
        this.clickSubmitBtn();
        this.bindingSelectizeFields();
    }
};
</script>

<style>
</style>